module.exports = __webpack_public_path__ + "static/img/percent.1c5a8e39.png";